import { doc, updateDoc } from "firebase/firestore";
import firebase from "../core/firebase";
import { Bussiness } from "./bussiness.entity";

export async function updateBussinessDisplayName(
  bussiness: Bussiness,
  name: string
): Promise<Bussiness> {
  const trimmed = name.trim();
  if (!trimmed) {
    throw new Error("Nome não pode ser vazio.");
  }

  await updateDoc(doc(firebase.db, "bussiness", bussiness.id), { name: trimmed });

  return new Bussiness(
    bussiness.id,
    trimmed,
    bussiness.domain,
    bussiness.image,
    bussiness.key
  );
}
